

























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {
    Multiselect: () => import("vue-multiselect"),
    FiltersAlert: () => import("@/components/filtersbar/FiltersAlert.vue")
  }
})
export default class SearchBar extends Vue {
  @Prop(Array) filtersWord!: any;
  @Prop(Object) filterFields!: any;
  @Prop(Function) removeFilterItem!: any;
  @Prop(Function) setFilters!: any;
  @Prop(Array) options!: any;
  windowWidth = 0;
  showSearch = false;
  value = [{ name: "Empleo profesional", code: 1 }];

  get filtersChild() {
    return (this as any).filtersWord;
  }

  set filtersChild(_) {
    return;
  }

  remove(event: any) {
    this.removeFilterItem(event);
  }

  addTag(newTag: any) {
    this.setFilters({ name: newTag, addTag: true, tag: "word" });
  }

  selectTag(newTag: any) {
    this.setFilters(newTag);
  }

  getMultiSelectLabel() {
    return this.filtersChild.some(e => e.label) ? "label" : "name";
  }

  show() {
    this.showSearch = true;
  }

  hide() {
    this.showSearch = false;
  }

  created() {
    window.addEventListener("resize", (this as any).$root.handleResize);
    (this as any).$root.handleResize();
  }
}
